import { ERROR_DATA_RE, SELECTOR_RE } from "./errors.constants";

export const extractErrorDataFromString = (value: string): string[] => {
  const dataMatches = value.match(ERROR_DATA_RE) || [];
  const selector = value.match(SELECTOR_RE)?.[1];
  return [
    ...dataMatches,
    selector,
    value,
  ].filter(Boolean) as string[];
};

export const extractErrorDataCandidates = (err: any, depth = 0): string[] => {
  if (!err || depth > 4) return [];
  if (typeof err === "string") return extractErrorDataFromString(err);

  const candidates = [
    typeof err.data === "string" ? err.data : undefined,
    typeof err.error?.data === "string" ? err.error.data : undefined,
    typeof err.error?.data?.data === "string" ? err.error.data.data : undefined,
    typeof err.info?.error?.data === "string" ? err.info.error.data : undefined,
  ].filter(Boolean) as string[];
  const stringCandidates = [
    typeof err.message === "string" ? err.message : undefined,
    typeof err.reason === "string" ? err.reason : undefined,
    typeof err.shortMessage === "string" ? err.shortMessage : undefined,
    typeof err.error?.message === "string" ? err.error.message : undefined,
    typeof err.info?.error?.message === "string"
      ? err.info.error.message
      : undefined,
    typeof err.data?.message === "string" ? err.data.message : undefined,
  ].filter(Boolean) as string[];

  return [
    ...candidates,
    ...candidates.flatMap(extractErrorDataFromString),
    ...stringCandidates.flatMap(extractErrorDataFromString),
    ...extractErrorDataCandidates(err.error, depth + 1),
  ];
};
